import React from 'react';
import { SnackbarProvider as SnackbarProviderBase } from 'notistack';

// STYLES
import { StyledMaterialDesignContent } from './styles';

const SnackbarProvider = props => {
  return (
    <SnackbarProviderBase
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        warning: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent,
      }}
      {...props}
    />
  );
};

SnackbarProvider.propTypes = {};

export default React.memo(SnackbarProvider);
